export default __webpack_public_path__ + "static/media/fig-21-fault-alternative.a3ee4b0d.png";